
import Draggable from 'vuedraggable'
import CompanyInfoMixin from '@/_mixins/companyInfo.mixin'

export default {
    name: 'NestedDraggable',
    mixins: [CompanyInfoMixin],
    components: {
        Draggable,
    },
    props: {
        disabled: Boolean,
        items: Array,
        move: Boolean,
        rememberExpanded: Boolean,
        moreMenu: Boolean,
        value: Array,
        multiple: Boolean,
        showActivityStatus: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            nodesExpanded: this.rememberExpanded ? this.$store.getters.nodesExpanded : {},
            showButtons: false,
            selectedItems: this.value || [],
        }
    },
    watch: {
        value: {
            handler(value) {
                this.selectedItems = value || []
            },
        },
    },
    computed: {
        nodes() {
            return this.items
        },
    },
    methods: {
        isVisible(item) {
            if (item._isMoving) return false
            if (item.isArchived) return item._isMatch
            return item._isMatch || item._isParentMatch || item.children.some(this.isVisible)
        },
        setNodesExpanded(nodesExpanded) {
            if (this.rememberExpanded) {
                this.$store.commit('setNodesExpanded', nodesExpanded)
            }

            this.nodesExpanded[nodesExpanded.id] = nodesExpanded.value
        },
        toggleChildren(node: any, event: MouseEvent, skipIfExpanded = false) {
            let button = event.currentTarget as HTMLButtonElement
            let item = button.parentElement?.closest('button') as HTMLButtonElement

            if (!item) return

            let expanded = item.dataset.expanded === 'true'
            if (expanded && skipIfExpanded) return

            let newExpanded = !expanded
            item.dataset.expanded = newExpanded.toString()

            this.setNodesExpanded({ id: node.id, value: newExpanded })
        },
        setLastVisibleItems() {
            const list = (this.$refs.list as Vue)?.$el as HTMLUListElement

            if (!list || list.childElementCount === 0) return

            const listItems = list.querySelectorAll(':scope > li') as NodeListOf<HTMLLIElement>
            if (listItems.length === 0) return
            listItems.forEach((item) => delete item.dataset.lastvisible)
            // mark last visible list item
            for (let i = listItems.length - 1; i >= 0; i--) {
                const item = listItems[i]
                if (item.style.display !== 'none') {
                    item.dataset.lastvisible = 'true'
                    break
                }
            }
        },
        selectContractor(item) {
            if (this.multiple) {
                if (this.selectedItems.some((value: any) => value.id === item.id)) {
                    this.selectedItems = this.selectedItems.filter(
                        (value: any) => value.id !== item.id
                    )
                } else {
                    this.selectedItems = [item, ...this.selectedItems]
                }
            } else {
                this.selectedItems = [item]
            }
            this.$emit('input', this.selectedItems)
        },
    },
    updated() {
        this.setLastVisibleItems()
    },
    mounted() {
        this.setLastVisibleItems()

        if (Array.isArray(this.selectedItems) && this.items.length > 0) {
            let value = this.items.find((item: any) =>
                this.selectedItems.some((valueItem: any) => valueItem.id === item.id)
            )
            if (value) {
                const el = document.querySelector(`[data-id="${value.id}"]`)
                el?.scrollIntoView()
            }
        }
    },
}
